import script from "./index.widget.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.widget.vue?vue&type=script&lang=ts&setup=true"

import "./index.widget.vue?vue&type=style&index=0&id=7194ac20&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7194ac20"]])

export default __exports__